import { UserBranchAccessList } from "./UserBranchAccessList";
import { UserBranchAccessCreate } from "./UserBranchAccessCreate";
import { UserBranchAccessEdit } from "./UserBranchAccessEdit";

export default {
    list: UserBranchAccessList,
    create: UserBranchAccessCreate,
    edit: UserBranchAccessEdit
};
